import { APP_STORE_URL, CHATGPT_DUPE_APP_URL } from '@dupe/common/constants'
import { useEffect, useState } from 'react'
import { isDesktop } from 'react-device-detect'
import AppLink from '~/src/components/AppLink'
import AppleIcon from '~/src/components/svg/AppleIcon'
import { cn } from '~/src/lib/utils'
import ChatGPTLogo from '~/src/components/svg/ChatGPTLogo'

interface Props {
  inline?: boolean
  appStoreCampaign?: string
}

const GetAppsContainer: React.FC<Props> = ({ appStoreCampaign, inline }) => {
  const [qrCode, setQrCode] = useState(false)

  useEffect(() => {
    setQrCode(isDesktop)
  }, [])

  return (
    <div
      className={cn(
        'bg-bellblue mx-auto space-y-10 rounded-lg text-black md:max-w-screen-sm',
        {
          'border-2 border-black px-4 py-6 md:px-16 md:py-10': !inline,
        }
      )}
    >
      <div className='space-y-2'>
        <h2 className='text-2xl font-semibold md:text-3xl'>Get the app</h2>
        <div>
          <AppLink
            label='iOS App'
            href={`${APP_STORE_URL}?pt=124011140&mt=8${appStoreCampaign ? `&ct=${appStoreCampaign}` : ''}`}
            logo={<AppleIcon width={30} height={30} />}
            qrCode={qrCode}
          />
        </div>
      </div>
      <div className='space-y-2'>
        <h2 className='text-2xl font-semibold md:text-3xl'>
          ChatGPT integration
        </h2>
        <div>
          <AppLink
            label='Dupe inside ChatGPT'
            href={CHATGPT_DUPE_APP_URL}
            logo={<ChatGPTLogo className='size-8' />}
          />
        </div>
      </div>
      <div className='space-y-2'>
        <h2 className='text-2xl font-semibold md:text-3xl'>
          Get the extension
        </h2>
        <div>
          <AppLink
            label='Chrome, Brave, Edge'
            href='https://chromewebstore.google.com/detail/dupe/pkhpcfoaocmmpmphhenoblggeinedlah'
            src='/assets/apps/chromium.png'
            width={113}
            height={31}
            last
          />
        </div>
      </div>
      {/* <div className='space-y-2'>
        <h2 className='text-2xl font-semibold md:text-3xl'>
          Get the iOS Shortcut
        </h2>
        <div>
          <AppLink
            label='Set up on iOS'
            href='https://www.icloud.com/shortcuts/57ce8140119843e2b2674f4556d2eba6'
            src='/assets/apps/ios-shortcut.png'
            width={31}
            height={36}
          />
        </div>
      </div> */}
    </div>
  )
}

export default GetAppsContainer
